import type AccessTokenDTO from '../dtos/access-token.dto'
import type LoginResponseDTO from '../dtos/login-response.dto'
import type AccessToken from '../models/access-token.interface'
import type { LoginResponse } from '../models/response.interface'
import { mapAppUserFromAppUserDTO } from '@/modules/app-user/mappers/app-user.mapper'

export function mapLoginResponseFromLoginResponseDTO(dto: LoginResponseDTO): LoginResponse {
  return {
    user: mapAppUserFromAppUserDTO(dto.user),
    permissions: dto.permissions,
    accessToken: mapAccessTokenFromAccessTokenDTO(dto.access_token),
  } as LoginResponse
}

export function mapAccessTokenFromAccessTokenDTO(dto: AccessTokenDTO): AccessToken {
  return {
    token: dto.token,
    type: dto.type,
    expiresIn: dto.expires_in,
  } as AccessToken
}
